import icons from '@/assets/icons'
import { couponList } from '@/services/payment'
import { Coupon, CouponListRes } from '@/services/types/payment'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import './index.less'

type CouponListProps = {
  onCouponChange: (coupon?: Coupon) => void
}
const CouponPicker = ({ onCouponChange }: CouponListProps) => {
  const [coupons, setCoupons] = useState<Coupon[]>([])
  const [code, setCode] = useState('')

  const fetchCouponList = async () => {
    const res = (await couponList()) as unknown as CouponListRes
    console.log('fetchCouponList', res)
    let _list = res.list.filter((item) => item.status === 0)
    setCoupons(_list)
    if (_list.length) {
      onCouponClick(_list[0])
    }
  }

  useEffect(() => {
    fetchCouponList()
  }, [])

  const onCouponClick = (coupon: Coupon) => {
    if (code === coupon.useCouponCode) {
      onCouponChange(undefined)
      setCode('')
    } else {
      onCouponChange(coupon)
      setCode(coupon.useCouponCode)
    }
  }
  return (
    <div className="coupon-list">
      {coupons.map((item) => (
        <div
          className={`coupon ${item.status > 0 && 'disabled'}`}
          key={item.useCouponCode}
          onClick={() => onCouponClick(item)}
        >
          <div className="top">
            <div className="desc">{item.desc}</div>
            <div className="info">
              <div className="name">{item.couponName}</div>
              <div className="num">
                <div className="symbol">¥</div>
                <div className="number">{item.couponAmount}</div>
                <img className="icon" src={require('./coupon.png')} alt="" />
              </div>
              <img
                className="icon-check"
                src={code === item.useCouponCode ? icons.IconRadioChecked : icons.IconRadioDefault}
                alt=""
              />
            </div>
          </div>
          <div className="bottom">
            <div className="date">
              有效期至：{dayjs(item.effectiveEndTime).format('YYYY-MM-DD')}
            </div>
          </div>
        </div>
      ))}
      {!coupons.length && (
        <div className="no-coupon">
          <img src={require('./no-coupon.png')} alt="" />
          <span>暂无可用优惠券</span>
        </div>
      )}
    </div>
  )
}

export default CouponPicker
